import React from "react";
import { Box, Typography, Select, MenuItem, IconButton } from "@mui/material";
import { FirstPage, LastPage, ChevronLeft, ChevronRight } from "@mui/icons-material";
import "./Pagination.css"

const Pagination = ({ count, rowsPerPage, page, onChangePage, onRowsPerPageChange }) => {
  const totalPages = Math.ceil(count / rowsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      onChangePage(newPage);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "10px",
        gap: 1,
      }}
    >
      <Typography variant="body2">Items per page:</Typography>
      <Select
        value={rowsPerPage}
        onChange={onRowsPerPageChange}
        size="small"
        sx={{ width: "70px" }}
      >
        {[5, 10, 15, 20].map((rows) => (
          <MenuItem key={rows} value={rows}>
            {rows}
          </MenuItem>
        ))}
      </Select>

      <Typography variant="body2">
        {page + 1}-{Math.min(count, (page + 1) * rowsPerPage)} of {count}
      </Typography>

      <IconButton onClick={() => handlePageChange(0)} disabled={page === 0}>
        <FirstPage />
      </IconButton>
      <IconButton onClick={() => handlePageChange(page - 1)} disabled={page === 0}>
        <ChevronLeft />
      </IconButton>
      <IconButton onClick={() => handlePageChange(page + 1)} disabled={page >= totalPages - 1}>
        <ChevronRight />
      </IconButton>
      <IconButton onClick={() => handlePageChange(totalPages - 1)} disabled={page >= totalPages - 1}>
        <LastPage />
      </IconButton>
    </Box>
  );
};

export default Pagination;
